import { useState } from "react";
import { Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/hooks/use-toast";
import api from "@/lib/api";

export default function DonationSummaryCard({ caseId, donationNeeded, donationReceived, onUpdated }) {
  const { toast } = useToast();
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(donationNeeded);

  const save = async () => {
    await api.patch(`/cases/${caseId}`, { donation_needed: parseFloat(value) || 0 });
    setEditing(false);
    onUpdated();
    toast({ title: "Donation needed updated" });
  };

  return (
    <div className="bg-amtm-surface border border-amtm-border rounded-2xl p-4 mb-6 flex items-center justify-between gap-3">
      <div>
        <p className="text-xs text-amtm-textMuted">Donation Needed</p>
        {editing ? (
          <div className="flex items-center gap-2 mt-1">
            <Input type="number" value={value} onChange={(e) => setValue(e.target.value)} className="h-9 w-32" data-testid="edit-donation-needed-input" />
            <Button size="sm" onClick={save} data-testid="save-donation-needed-button">Save</Button>
          </div>
        ) : (
          <p className="font-semibold text-lg text-amtm-text">₹{donationNeeded?.toLocaleString("en-IN")}</p>
        )}
      </div>
      {!editing && (
        <button onClick={() => setEditing(true)} data-testid="edit-donation-needed-button" className="text-amtm-teal">
          <Pencil className="h-4 w-4" />
        </button>
      )}
      <div className="text-right">
        <p className="text-xs text-amtm-textMuted">Received</p>
        <p className="font-semibold text-lg text-amtm-success">₹{donationReceived?.toLocaleString("en-IN")}</p>
      </div>
    </div>
  );
}
